export default "__VITE_ASSET__AhRdrKPN__"